// extracted by mini-css-extract-plugin
export default {"text":"RefNumTemplate_text__YPdo0","addText":"RefNumTemplate_addText__n-qWv","icon":"RefNumTemplate_icon__Dp4Ha","iconWithValue":"RefNumTemplate_iconWithValue__5D4St"};